import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { startSyncCoordinator } from '../services/syncCoordinator';

export function useSyncCoordinator(): void {
  const connectionStatus = useAuthStore((state) => state.connectionStatus);

  useEffect(() => {
    if (connectionStatus !== 'connected') return;
    return startSyncCoordinator();
  }, [connectionStatus]);
}

export const SyncCoordinator = (): null => {
  useSyncCoordinator();
  return null;
};